/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap';
import './Loading.css'

const FullScreenLoading = (props) => {
    const {show, content} = props;

    if (show) {
        return (
            <Modal show={show} className="global-full-screen-loading">
                <div className="full-screen-loading-body">
                    <i className="icon" aria-hidden="true">{}</i>
                    <p className="font-body3" data-key={ content.dataKey }>{ content.text }</p>
                </div>
            </Modal>
        );
    }

    return null;
};

FullScreenLoading.propTypes = {
    show: PropTypes.bool,
    content: PropTypes.object
};

FullScreenLoading.defaultProps = {
    show: false,
    content: {text: 'Loading', dataKey: 'global-full-screen-loading'}
};

export default FullScreenLoading


// WEBPACK FOOTER //
// ./src/shared/Loading/components/FullScreenLoading.js